import React from "react";

import AppWrapper from "../../components/cm/AppWrapper";
import UserProfileManager from "../../components/cm/Dashboard/FullPages/UserManager/UserProfileManager";
import SideBarMain from "../../components/cm/SideBarMain";

export default function UserProfielTemplate() {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
      <UserProfileManager />
    </AppWrapper.WithSidebar>
  );
}
